/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'grid';
const prefix = `${moduleName}.${componentName}`;

export const emptyListMessage = `${prefix}.emptyListMessage`;
export const noItemsMatchMsg = `${prefix}.noItemsMatchMsg`;
export const displayItemsPlural = `${prefix}.displayItemsPlural`;
export const searchInputPlaceholder = `${prefix}.searchInputPlaceholder`;

export const ENGLISH = {
    [emptyListMessage]: 'No items found',
    [noItemsMatchMsg]: 'No items match your search criteria',
    [displayItemsPlural]: '{0, plural, one{Displaying # item} other{Displaying # items}}',
    [searchInputPlaceholder]: 'Search',
};
